import * as Dashboard from './dashboard';
import * as SignIn from './signIn';

export const StripeConnect = {
  ...SignIn,
  SignIn,
  Dashboard,
};
